export const getPropertiesValues = (object, excludePropertyName) => {
    const fieldsValues = [];
    for (const [key, value] of Object.entries(object)) {
      if (key === excludePropertyName) {
      } else fieldsValues.push(`${value}`);
    }
    return fieldsValues;
  };
  